import * as React from 'react';
import { IProduct } from 'src/types/products';
import Modal from 'src/view/components/Controls/Modal/Modal';
import './style.scss';
import { observer } from 'mobx-react';
import ButtonComponent from 'src/view/components/Controls/Button/Button';
import { localeStore } from 'src/mobx/localesStore';
import ResponsiveContent from 'src/view/components/ResponsiveContent/ResponsiveContent';
import { IProductInsideCombo } from 'src/types/combo';
import { useNutrientModalInfo } from './hooks/useNutrientModalInfo';

interface IProps {
  product?: IProduct | IProductInsideCombo;
  isOpen: boolean;
  onClose: () => void;
}

const NutrientModal: React.FC<IProps> = ({ product, isOpen, onClose }) => {
  const { getInfo } = useNutrientModalInfo(product);

  return (
    <Modal defaultAnimation={''} className="nutrient-modal" isOpen={isOpen} onRequestClose={onClose}>
      <article className="nutrient fadein">
        <ResponsiveContent max={1024}>
          <div onClick={onClose} className={'nutrient-pane'} />
        </ResponsiveContent>
        <ul className="nutrient-ul">{getInfo()}</ul>
        <footer className="nutrient-footer">
          <ButtonComponent
            fullSize
            onClick={onClose}
            className={'nutrient-button'}
            id={'product_submit'}
            title={localeStore.t('got_it')}
          />
        </footer>
      </article>
    </Modal>
  );
};

export default observer(NutrientModal);
